import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {AutoplayView} from '@gongxigames/framework/slot/modules/autoplay/AutoplayView';
import {AutoplayModule} from '@gongxigames/framework/slot/modules/autoplay/AutoplayModule';

// @ts-ignore
export class AutoplayBasicState extends ModuleState<AutoplayView, AutoplayModule> {

    public onEnterState(): void {
        this.module.stopAutoplay();
    }

    public onLeaveState(): void {
        this.view.showAutoplayUI();
    }

    protected setupEvents(): void {
        this.setEventHandler('Autoplay.START', this.onStartAutoplayButtonClicked.bind(this));
    }

    protected onStartAutoplayButtonClicked(options: any): void {
        this.module.startAutoplay(options);
    }
}
